import { Table, BarChart3 } from 'lucide-react';
import { cn } from '@shared';
import { Button } from '@/components/ui/Button';

export type ReportViewMode = 'table' | 'chart';

interface ChartViewToggleProps {
  view: ReportViewMode;
  onChange: (view: ReportViewMode) => void;
}

export function ChartViewToggle({ view, onChange }: ChartViewToggleProps) {
  return (
    <div className="inline-flex items-center rounded-md bg-muted p-1">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onChange('table')}
        className={cn(
          'h-8 gap-1.5 rounded-sm px-3 text-xs font-medium transition-colors',
          view === 'table'
            ? 'bg-selected text-primary shadow-sm'
            : 'text-muted-foreground hover:bg-muted hover:text-foreground'
        )}
        aria-pressed={view === 'table'}
      >
        <Table className="h-3.5 w-3.5" />
        Table
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() => onChange('chart')}
        className={cn(
          'h-8 gap-1.5 rounded-sm px-3 text-xs font-medium transition-colors',
          view === 'chart'
            ? 'bg-selected text-primary shadow-sm'
            : 'text-muted-foreground hover:bg-muted hover:text-foreground'
        )}
        aria-pressed={view === 'chart'}
      >
        <BarChart3 className="h-3.5 w-3.5" />
        Chart
      </Button>
    </div>
  );
}
